import React from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

const reorderData = [
  { item: 'Carmozyme 250mg', category: 'Carmozyme', cur: 18, days: 4, incoming: 0, qty: 200, vendor: 'AHB Pharma', risk: 'critical' },
  { item: 'Carmozyme 500mg', category: 'Carmozyme', cur: 9, days: 2, incoming: 50, qty: 150, vendor: 'AHB Pharma', risk: 'critical' },
  { item: 'Carmozyme Syrup', category: 'Carmozyme', cur: 34, days: 11, incoming: 0, qty: 100, vendor: 'AHB Pharma', risk: 'low' },
  { item: 'Analgesic Syrup', category: 'Analgesic', cur: 32, days: 9, incoming: 0, qty: 150, vendor: 'MediLife Ltd', risk: 'low' },
  { item: 'Antibiotic Cap 500', category: 'Antibiotic', cur: 11, days: 3, incoming: 0, qty: 220, vendor: 'XYZ Chemicals', risk: 'critical' },
  { item: 'Antibiotic Cap 250', category: 'Antibiotic', cur: 27, days: 8, incoming: 100, qty: 180, vendor: 'XYZ Chemicals', risk: 'low' },
  { item: 'Antibiotic Syrup', category: 'Antibiotic', cur: 30, days: 10, incoming: 0, qty: 120, vendor: 'XYZ Chemicals', risk: 'low' },
  { item: 'Ayurvedic Tonic', category: 'Ayurvedic', cur: 22, days: 12, incoming: 0, qty: 120, vendor: 'HealthCorp', risk: 'low' },
];

const riskColors = {
  critical: 'red',
  low: 'amber',
};

export default function ReorderTableCard() {
  return (
    <Box className="card" style={{ minHeight: '400px' }}>
      <div className="card-head">
        <h3 className="card-title" id="opsReorderTitle">Reorder & stockout risk — Aug</h3>
        <span className="reset-tag" onClick={() => window.opsShowRiskAll?.()}>View all 8 at-risk</span>
      </div>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Item</TableCell>
              <TableCell>Category</TableCell>
              <TableCell align="right">Current</TableCell>
              <TableCell align="right">Days Rem.</TableCell>
              <TableCell align="right">Incoming</TableCell>
              <TableCell align="right">Reorder Qty</TableCell>
              <TableCell>Vendor</TableCell>
              <TableCell>Risk</TableCell>
            </TableRow>
          </TableHead>
          <TableBody id="opsReorderBody">
            {reorderData.map((row, i) => (
              <TableRow key={i} hover className="row-click" onClick={() => window.openS360?.(row.vendor)}>
                <TableCell>{row.item}</TableCell>
                <TableCell>{row.category}</TableCell>
                <TableCell align="right">{row.cur}</TableCell>
                <TableCell align="right">{row.days}d</TableCell>
                <TableCell align="right">{row.incoming || '—'}</TableCell>
                <TableCell align="right">{row.qty}</TableCell>
                <TableCell><span className="vendor-link">{row.vendor}</span></TableCell>
                <TableCell>
                  <span className={`pill ${riskColors[row.risk]}`}>
                    {row.risk.charAt(0).toUpperCase() + row.risk.slice(1)}
                  </span>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <div style={{ marginTop: 12, fontSize: '12px', color: 'var(--text-sec)' }} id="opsReorderCount">
        {reorderData.length} shown
      </div>
    </Box>
  );
}
